
import { Component } from 'react';
import LabeledContainer from '../../../../components/LabeledContainer';
import ResponsiveTable from '../../../../components/ResponsiveTable';
import DateTime from '../../../../components/DateTime';
import { formatDate, formatMoney, getCustomerFullName } from '../../../../../../shared/utils';
import { IconButton } from '@mui/material';
import { Download } from '@mui/icons-material';
import PDF from '../../../../PDF';


const TYPE = {
   PAYMENT: 'Payment',
   PENALTY: 'Late payment penalty',
   COMPOUNDING: 'Compounding',
   WRITE_OFF: 'Write off',
}


export default class Statement extends Component {

   getItems() {

      const { payments, penalties, compoundings, write_offs } = this.props.loan;
      
      const items = [];

      items.push(
         ...payments
            .filter(payment => payment.paid)
            .map((payment) => {
               return {
                  type: TYPE.PAYMENT,
                  date: payment.paid_at,
                  amount: payment.amount,
                  balance: 0
               };
            })
      );

      items.push(
         ...penalties.map(penalty => {
            return {
               type: TYPE.PENALTY,
               date: penalty.created_at,
               amount: penalty.amount,
               balance: 0
            };
         })
      );

      items.push(
         ...compoundings.map(compounding => {
            return {
               type: TYPE.COMPOUNDING,
               date: compounding.created_at,
               amount: compounding.amount,
               balance: 0
            };
         })
      );

      items.push(
         ...write_offs.map(write_off => {
            return {
               type: TYPE.WRITE_OFF,
               date: write_off.created_at,
               amount: write_off.amount,
               balance: 0
            };
         })
      );

      items.sort((a, b) => {
         if (a.date < b.date) {
            return -1;
         } else if (a.date > b.date) {
            return 1;
         } else {
            return 0;
         }
      });

      const reversed = items.toReversed();
      let balance = this.props.loan.owing;

      reversed.forEach(item => {
         item.balance = balance;
         if ([TYPE.PAYMENT, TYPE.WRITE_OFF].includes(item.type))
            balance += item.amount;
         else
            balance -= item.amount;
      });

      return items;

   }

   saveAsPDF = () => {

      const { loan } = this.props;
      const { loan_no, customer, owing } = loan;
      const name = getCustomerFullName(customer);

      const pdf = new PDF(`Loan Statement`);

      // details
      pdf.addHorizontalTable({
         data: {
            'Loan No': loan_no,
            'Customer': name,
            'Product': loan.product.name,
            'Applied': formatDate(loan.created_at),
            'Issued': formatDate(loan.issued_at),
         }
      });

      // add statement
      pdf.addSpace();

      const items = this.getItems();

      const headers = [ 'Date', 'Type', 'Amount', 'Balance' ];
      
      const rows = items.map(item => {
         return [
            formatDate(item.date, { time: true }),
            item.type,
            item.amount,
            item.balance
         ]
      });

      pdf.addTable({
         headers,
         rows
      });

      pdf.addHTML(
         `
            <div class="flex justify-end pb-4 pr-4 text-sm bg-orange-400 text-white">
               Balance: <b>${formatMoney(owing)}</b>
            </div>
         `
      )

      // save 
      pdf.save();


   }

   render() {

      const items = this.getItems();

      return <LabeledContainer label="Loan Statement" className='p-4 rounded-lg'>
         <div className='h-[400px]'>
            <ResponsiveTable
               cols={[
                  {
                     field: 'date',
                     caption: 'Date',
                     render: date => <DateTime value={date} />
                  },
                  {
                     field: 'type',
                     caption: 'Type',
                  },
                  {
                     field: 'amount',
                     caption: 'Amount',
                     render: formatMoney,
                     rightAlign: true
                  },
                  {
                     field: 'balance',
                     caption: 'Balance',
                     render: formatMoney,
                     rightAlign: true
                  }
               ]}
               rows={items}
               fullHeight
            />
         </div>
         <div className='flex justify-end'>
            <IconButton color="primary" onClick={this.saveAsPDF}>
               <Download />
            </IconButton>
         </div>
      </LabeledContainer>
   }

}